import { createContext, useContext } from "react";

import type { ExportablesModalContextValue } from "./ExportablesModalContext.types";

export const ExportablesContext =
  createContext<ExportablesModalContextValue | null>(null);

export const useExportablesModalContext = (): ExportablesModalContextValue => {
  const context = useContext(ExportablesContext);
  if (!context) {
    throw new Error(
      "Exportables compound components must be used within a Exportables context",
    );
  }
  return context;
};
